import { userFactory } from '@/lib/business/models/User';

class DeploymentIndexUserResult {
  users = [];
  
  nextCursor = '';

  hasMore = false;

  constructor(result) {
    this.users = userFactory.createUsers(result.users);
    this.nextCursor = result.nextCursor;
    this.hasMore = result.hasMore;
  }

  static fromObject(data) {
    if (data == null) {
      return null;
    }
    return new DeploymentIndexUserResult(data);
  }
}

export default DeploymentIndexUserResult;
